export type DayPeriod = 'lunch' | 'dinner'

export interface TimeSlot {
  value: string
  label: string
  period: DayPeriod
}

const MAIA_OPENING_HOURS = {
  weekday: {
    lunch: { open: '12:00', close: '14:30' },
    dinner: { open: '19:00', close: '22:30' },
  },
  saturday: {
    lunch: { open: '12:00', close: '14:30' },
  },
  sunday: null,
} as const

export function parseTime(time: string): number {
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}

function formatTime(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = minutes % 60
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

function generateSlots(
  open: string,
  close: string,
  period: DayPeriod
): TimeSlot[] {
  const start = parseTime(open)
  const end = parseTime(close)
  // Last sitting starts 60 minutes before closing.
  const lastStart = end - 60
  const slots: TimeSlot[] = []
  for (let t = start; t <= lastStart; t += 30) {
    slots.push({ value: formatTime(t), label: formatTime(t), period })
  }
  return slots
}

export function getAvailableSlots(date: Date): TimeSlot[] {
  const day = date.getDay() // 0 = Sunday, 6 = Saturday
  if (day === 0) return []
  if (day === 6) {
    const hours = MAIA_OPENING_HOURS.saturday
    if (!hours) return []
    return generateSlots(hours.lunch.open, hours.lunch.close, 'lunch')
  }
  const hours = MAIA_OPENING_HOURS.weekday
  return [
    ...generateSlots(hours.lunch.open, hours.lunch.close, 'lunch'),
    ...generateSlots(hours.dinner.open, hours.dinner.close, 'dinner'),
  ]
}

export function isDateClosed(date: Date): boolean {
  return date.getDay() === 0
}

export function parseDateInput(value: string): Date {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatDateInput(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}
